var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00033 12.25C9.04199 10.15 11.0837 8.26957 11.0837 5.95C11.0837 3.6304 9.25549 1.75 7.00033 1.75C4.74516 1.75 2.91699 3.6304 2.91699 5.95C2.91699 8.26957 4.95866 10.15 7.00033 12.25Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.58594C7.96652 7.58594 8.75 6.80246 8.75 5.83594C8.75 4.86944 7.96652 4.08594 7 4.08594C6.03347 4.08594 5.25 4.86944 5.25 5.83594C5.25 6.80246 6.03347 7.58594 7 7.58594Z",
    fill: "#0D0D0D",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation3);
export default __webpack_public_path__ + "static/media/location-3.5821b864711c20caebc6121db80f1ffe.svg";
export { ForwardRef as ReactComponent };